/**
 * Created by afuhr on 23.01.2017.
 */
import * as _ from "lodash";
import {FormArray, FormControl} from "@angular/forms";
import {ChangeDetectorRef, EventEmitter, Input, Output} from "@angular/core";
import {AbstractVisbosComponent} from "../../components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

export abstract class AbstractListView extends AbstractVisbosComponent {

  @Input()
  immutable: boolean = true;

  editing: { [cuid: string]: boolean } = {};
  columns = [];

  private _rows: Array<any> = [];

  set rows(data: Array<any>) {
    this._rows = data;
  };

  get rows(): Array<any> {
    return this._rows || [];
  }

  @Input()
  isLoading: boolean = false;

  messages = {
    emptyMessage: 'Keine Einträge vorhanden',
    totalMessage: 'Einträge insgesamt'
  };

  private _searchTerm: FormControl;

  get searchTerm(): FormControl {
    if (!this._searchTerm) {
      this.searchTerm = new FormControl();
    }
    return this._searchTerm;
  }

  @Input()
  set searchTerm(value: FormControl) {
    this._searchTerm = value;
  }

  private _selectedItems: any[] = [];

  @Input()
  set selectedItems(value: any[]) {
    this._selectedItems = value || [];
    this.selectedItemsChange.emit(this.selectedItems);
  }

  get selectedItems(): any[] {
    return this._selectedItems || [];
  }

  @Output()
  selectedItemsChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Input()
  currentSearchTermValue: BehaviorSubject<string> = new BehaviorSubject<string>(null);


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();
  }

  protected findStringInTable(item, columns, searchString): boolean {

    // Iterate over all columns of the data table and try to find the search string in each column
    for (let col of columns) {
      let obj: any = _.get(item, col.prop);

      if (col.comperator) {

      }

      if (obj) {
        let val = (obj instanceof Object) ? JSON.stringify(obj) : obj.toString();
        if (val.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }
      }

    }

    return false;
  }

  updateValue(event, cell, cellValue, row, index): any {

    let newRows = JSON.parse(JSON.stringify(this.rows));
    newRows[index][cell] = event.target.value;

    this.editing[index + '-' + cell] = false;
    let res = {[cell]: event.target.value};

    this.onCellUpdate(row, res, index);

    return res;
  }

  isRowSelected(row, cuidPath: string = 'cuid'): boolean {
    return this.selectedItems.find(i => i === row[cuidPath]) !== null;
  }

  onCellUpdate(row, res, index) {

  };

  onSelectedChanged(selected: any[]) {
    this.selectedItems = selected;
  }

  findCuidInFormArray(cuid: string, formArray: FormArray) {
    const val: any[] = formArray.value;
    return val.findIndex((content) => {
      return content.cuid && content.cuid == cuid;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/abstract-list-view.ts